import { render, staticRenderFns } from "./ManualAddress.vue?vue&type=template&id=aaa5e39e&scoped=true"
import script from "./ManualAddress.vue?vue&type=script&lang=js"
export * from "./ManualAddress.vue?vue&type=script&lang=js"
import style0 from "./ManualAddress.vue?vue&type=style&index=0&id=aaa5e39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5e39e",
  null
  
)

export default component.exports